<div class="container-fluid d-flex flex-column p-0">
  <!-- Top Navbar -->
  <header class="public-header" #publicHeader>
    <nav class="public-header__nav" aria-label="Primary">
      <a
        class="public-header__brand"
        href="#"
        (click)="onLogoClick($event)"
        aria-label="First Orion"
      >
        <img
          src="assets/images/fo-logo.svg"
          class="public-header__logo"
          alt="First Orion"
        />
      </a>

      <button
        type="button"
        class="public-header__mobile-toggle"
        (click)="toggleMobileMenu()"
        [attr.aria-expanded]="isMobileMenuOpen"
        aria-label="Toggle menu"
      >
        <svg
          *ngIf="!isMobileMenuOpen"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <rect
            x="2"
            y="4.5"
            width="16"
            height="2"
            rx="1"
            fill="currentColor"
          />
          <rect x="2" y="9" width="16" height="2" rx="1" fill="currentColor" />
          <rect
            x="2"
            y="13.5"
            width="16"
            height="2"
            rx="1"
            fill="currentColor"
          />
        </svg>
        <svg
          *ngIf="isMobileMenuOpen"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M4 4L16 16M16 4L4 16"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </button>

      <div class="public-header__links" aria-label="Header links">
        <a
          class="public-header__link"
          href="#walkthrough"
          (click)="scrollToSection($event, 'walkthrough')"
          >Platform</a
        >
        <a
          class="public-header__link"
          href="#pricing"
          (click)="scrollToSection($event, 'pricing')"
          >Pricing</a
        >
        <a
          class="public-header__link"
          href="#coverage"
          (click)="scrollToSection($event, 'coverage')"
          >Coverage</a
        >
        <a
          class="public-header__link"
          href="#testimonials"
          (click)="scrollToSection($event, 'testimonials')"
          >Testimonials</a
        >
      </div>

      <div class="public-header__actions">
        <div class="public-header__currency" #currencyToggle>
          <button
            type="button"
            class="public-header__currency-trigger"
            [class.is-open]="isCurrencyMenuOpen"
            (click)="toggleCurrencyMenu()"
            [attr.aria-expanded]="isCurrencyMenuOpen"
            aria-haspopup="listbox"
            aria-label="Select currency"
          >
            <span class="public-header__currency-symbol">{{ currentCurrency.symbol }}</span>
            <span class="public-header__currency-code">{{ currentCurrency.code }}</span>
            <svg
              class="public-header__currency-chevron"
              [class.is-open]="isCurrencyMenuOpen"
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
          </button>

          <div class="public-header__currency-menu" *ngIf="isCurrencyMenuOpen" role="listbox">
            <button
              type="button"
              *ngFor="let c of currencies"
              class="public-header__currency-option"
              role="option"
              [attr.aria-selected]="c.code === currentCurrency.code"
              (click)="selectCurrency(c.code)"
            >
              <span class="public-header__currency-option-left">
                <span class="public-header__currency-option-symbol">{{ c.symbol }}</span>
                <span class="public-header__currency-option-code">{{ c.code }}</span>
              </span>
              <svg
                *ngIf="c.code === currentCurrency.code"
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M20 6 9 17l-5-5" />
              </svg>
            </button>
          </div>
        </div>

        <a
          class="public-header__action public-header__action--ghost"
          href="javascript:;"
          (click)="login()"
          >Log in</a
        >
        <button
          type="button"
          class="public-header__action public-header__action--primary"
          (click)="onSignUp()"
        >
          <span class="public-header__action--primary-shine" aria-hidden="true"></span>
          <span class="public-header__action--primary-sweep" aria-hidden="true"></span>
          <span class="public-header__action--primary-label">Sign Up</span>
        </button>
      </div>
    </nav>

    <div
      class="public-header__mobile-menu"
      *ngIf="isMobileMenuOpen"
      aria-label="Mobile menu"
    >
      <a
        class="public-header__mobile-link"
        href="#walkthrough"
        (click)="scrollToSection($event, 'walkthrough')"
        >Platform</a
      >
      <a
        class="public-header__mobile-link"
        href="#pricing"
        (click)="scrollToSection($event, 'pricing')"
        >Pricing</a
      >
      <a
        class="public-header__mobile-link"
        href="#coverage"
        (click)="scrollToSection($event, 'coverage')"
        >Coverage</a
      >
      <a
        class="public-header__mobile-link"
        href="#testimonials"
        (click)="scrollToSection($event, 'testimonials')"
        >Testimonials</a
      >

      <div class="public-header__mobile-divider" aria-hidden="true"></div>

      <div class="public-header__mobile-actions">
        <a
          class="public-header__mobile-action"
          href="javascript:;"
          (click)="login()"
          >Log in</a
        >
        <button
          type="button"
          class="public-header__mobile-cta"
          (click)="onSignUp()"
        >
          Sign Up
        </button>
      </div>
    </div>
  </header>

  <!-- Main Content -->
  <div class="public-content flex-grow-1">
    <router-outlet></router-outlet>
  </div>
  <!-- Plan prompt modal -->
  <ng-container *ngIf="planPromptOpen">
    <div
      class="icip-plan-prompt__backdrop"
      @backdrop
      (click)="closePlanPrompt()"
    ></div>
    <div class="icip-plan-prompt__wrap" @modal>
      <div class="icip-plan-prompt" (click)="$event.stopPropagation()">
        <button
          type="button"
          class="icip-plan-prompt__close"
          (click)="closePlanPrompt()"
          aria-label="Close"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M18 6 6 18" />
            <path d="M6 6 18 18" />
          </svg>
        </button>
        <div class="icip-plan-prompt__body">
          <div class="icip-plan-prompt__icon-wrap" aria-hidden="true">
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
            </svg>
          </div>
          <h3 class="icip-plan-prompt__title">
            Get started faster with a prepaid plan
          </h3>
          <p class="icip-plan-prompt__message">
            Our self-serve plans let you launch branded calling in minutes - no
            lengthy approval process required. Select a plan upfront and your
            account will be ready to activate as soon as your business details
            are verified.
          </p>
          <div class="icip-plan-prompt__actions">
            <button
              type="button"
              class="icip-plan-prompt__btn icip-plan-prompt__btn--primary"
              (click)="choosePlan()"
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <path d="M5 12H19" />
                <path d="M13 6l6 6-6 6" />
              </svg>
              Yes, Show Me Plans
            </button>
            <button
              type="button"
              class="icip-plan-prompt__btn icip-plan-prompt__btn--secondary"
              (click)="talkToSales()"
            >
              Talk to Sales
            </button>
          </div>
          <p class="icip-plan-prompt__note">
            Not sure which plan fits? Our team can help you choose.
          </p>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- <footer class="py-2 mt-3">
    <div class="container">
      <div class="row">
        <div class="col-12 mb-4">
          <app-footer-link></app-footer-link>
        </div>
      </div>
    </div>
  </footer> -->
</div>
